import { Type } from 'lucide-react';

// Map font IDs to Google Fonts family names for CSS
const FONT_FAMILY_MAP = {
  'dancing-script': '"Dancing Script", cursive',
  'alex-brush': '"Alex Brush", cursive',
  'allura': '"Allura", cursive',
  'cedarville-cursive': '"Cedarville Cursive", cursive',
  'great-vibes': '"Great Vibes", cursive',
  'italianno': '"Italianno", cursive',
  'satisfy': '"Satisfy", cursive',
  'prima-cursive': 'cursive',
  'd-nealian': 'cursive',
  'delius': '"Delius", sans-serif',
  'edu-sa-hand': '"Edu SA Hand", sans-serif',
  'edu-vicwa-hand': '"Edu VIC WA NT Hand", sans-serif',
  'itim': '"Itim", sans-serif',
  'public-sans': '"Public Sans", sans-serif',
  'solitreo': '"Solitreo", serif',
  'writing-step': 'sans-serif'
};

export default function FontRecommendation({ recommendedFonts }) {
  if (!recommendedFonts) return null;

  return (
    <div className="card">
      <h2 className="text-lg font-semibold mb-4">Recommended Practice Fonts</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {recommendedFonts.cursive && (
          <FontCard
            label="Cursive"
            font={recommendedFonts.cursive}
          />
        )}
        {recommendedFonts.print && (
          <FontCard
            label="Print"
            font={recommendedFonts.print}
          />
        )}
      </div>
    </div>
  );
}

function FontCard({ label, font }) {
  const fontFamily = FONT_FAMILY_MAP[font.fontId] || 'sans-serif';

  return (
    <div className="bg-bastion-gray-50 rounded-lg p-4">
      <div className="flex items-center gap-2 mb-2">
        <Type className="w-4 h-4 text-bastion-blue-500" />
        <span className="text-xs font-semibold uppercase tracking-wider text-bastion-gray-700">{label}</span>
      </div>
      <p
        className="text-2xl text-bastion-black mb-2 leading-relaxed"
        style={{ fontFamily }}
      >
        {font.fontName}
      </p>
      <p className="text-sm text-bastion-gray-800">{font.reason}</p>
    </div>
  );
}
